module.exports = __webpack_public_path__ + "img/clubicon-paint.2f399b09.png";